import { render, staticRenderFns } from "./CrewChangeTaskList.vue?vue&type=template&id=2fd24a42&scoped=true"
import script from "./CrewChangeTaskList.vue?vue&type=script&lang=js"
export * from "./CrewChangeTaskList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd24a42",
  null
  
)

export default component.exports